import NopeRef from './ref';

/** The sibling values made available to a rule, keyed by field name. */
export type NopeContext = Record<string, unknown>;

/** Error for a single field: the message string, or `undefined` when valid. */
export type FieldError = string | undefined;

/** Error map produced by validating an object shape, keyed by field name. */
export type ObjectErrors = Record<string, string>;

/** Anything a `validate` call can return. */
export type ValidationResult = FieldError | ObjectErrors;

/** Common shape implemented by every Nope validator. */
export type NopeValidator = {
  validate(value: unknown, context?: NopeContext, objectShape?: ObjectShape): ValidationResult;
};

/** The map passed to `NopeObject.shape`, pairing each field with a validator. */
export type ObjectShape = Record<string, NopeValidator>;

/** A single validation rule; returns a message on failure, otherwise a falsy value. */
export type ValidationRule = (
  value: unknown,
  context?: NopeContext,
  objectShape?: ObjectShape,
) => string | false | undefined;

export const resolveNopeRefs = (value: unknown, context?: NopeContext): unknown => {
  if (value instanceof NopeRef) {
    return context?.[value.key];
  } else if (Array.isArray(value)) {
    return value.map((option) => {
      if (option instanceof NopeRef) {
        return context?.[option.key];
      }

      return option;
    });
  } else {
    return value;
  }
};

export const required =
  (message: string): ValidationRule =>
  (value) => {
    const resolvedValue = resolveNopeRefs(value);

    return !resolvedValue && message;
  };
